var _circle, _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7126,
    cy: 9.12061,
    r: 5.28736,
    fill: "#7A67FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6057 18.2227C16.5997 16.8208 17.1839 15.108 17.1839 13.2587C17.1839 8.5135 13.3372 4.66675 8.59196 4.66675C3.84675 4.66675 0 8.5135 0 13.2587C0 18.0039 3.84675 21.8507 8.59196 21.8507C10.0553 21.8507 11.4331 21.4848 12.6391 20.8397C12.64 20.8401 12.6409 20.8404 12.6418 20.8408L15.629 22.1066C16.357 22.4151 17.0914 21.6829 16.7853 20.954L15.722 18.4224C15.6912 18.349 15.6519 18.2823 15.6057 18.2227Z",
    fill: "url(#paint0_linear_3463_4777)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3463_4777)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9776 4.99995C9.21495 5.85736 8.00012 7.66551 8.00012 9.7574C8.00012 12.6775 10.3674 15.0448 13.2875 15.0448C14.5186 15.0448 15.6514 14.624 16.55 13.9185C16.5778 13.6368 16.5921 13.3511 16.5921 13.062C16.5921 9.36354 14.2553 6.21088 10.9776 4.99995Z",
    fill: "#7145CB",
    fillOpacity: 0.74
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50765 13.4791C5.50765 14.2091 4.91584 14.8009 4.18581 14.8009C3.45578 14.8009 2.86397 14.2091 2.86397 13.4791C2.86397 12.749 3.45578 12.1572 4.18581 12.1572C4.91584 12.1572 5.50765 12.749 5.50765 13.4791ZM10.3544 13.4791C10.3544 14.2091 9.7626 14.8009 9.03257 14.8009C8.30254 14.8009 7.71073 14.2091 7.71073 13.4791C7.71073 12.749 8.30254 12.1572 9.03257 12.1572C9.7626 12.1572 10.3544 12.749 10.3544 13.4791ZM13.4387 14.8009C14.1687 14.8009 14.7605 14.2091 14.7605 13.4791C14.7605 12.749 14.1687 12.1572 13.4387 12.1572C12.7087 12.1572 12.1169 12.749 12.1169 13.4791C12.1169 14.2091 12.7087 14.8009 13.4387 14.8009Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3463_4777",
    x: 3,
    y: 0,
    width: 18.592,
    height: 20.0449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_3463_4777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3463_4777",
    x1: 6.4015e-8,
    y1: 13.4229,
    x2: 17.1839,
    y2: 13.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon1);
export default __webpack_public_path__ + "static/media/navicon1.4b68c7ea4323cd18e42dd9247965e8da.svg";
export { ForwardRef as ReactComponent };